var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"full-width",attrs:{"id":"login"}},[_c('div',{class:_vm.$q.screen.gt.sm ? 'container' : ''},[_c('FormCadastro')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }